import React, { useState, useEffect, useMemo } from "react";
import { FiChevronRight } from "react-icons/fi";
import SubM from "../../assets/images/next.png";
import Notifications from "../Notifictions/OnlineTransactions/Notifications";
import { useSelector } from "react-redux";
import { selectMenuPermissions } from "../../app/permissionsSlice";
const MenuBar = ({
  userType,
  allForms,
  agentCode,
  dbCode,
  openReceiptModal,
  openPEntry,
  openCashRec,
  openCashPay,
  openFormRegModal,
  openProductRegModal,
  openDayBookModal,
  openJvModal,
  openCvModal,
  openLedgerDiaModal,
  openAgReportDiaModal,
  openQuickSearchModal,
  downloadBackup,
  openSmsSettings,
  openWhatsAppSettings,
  openLedgerListModal,
  openOverDueListModal,
  openEventDetailsModal,
  openRateSettingsModal,
  openRateClassModal,
  openStockGroupModal,
  openModelRegModal,
  openStaffRegModal,
  openCreateUserModal,
  openReceiptListModal,
  openRegistrationModal,
  openSchManagementModal,
  openLedgerRegModal,
  openOtherRegModal,
  openRedeemModal,
  openSoftwareSettings,
  openFinancialYear,
  openGroupreg,
  openGroupListModal,
  openGoldReceipt,
  openPurchaseList,
  openSchemeReport,
  openCustomerAppRegModal,
  openAppBroadcastManager,
  openAppConfigMaster,
  openPaymentGatewaySettings,
  openInvoiceDesigner,
  openPrintModelAssigner
}) => {
  // ////console.log("allRec12121eipts==", allReceipts);
  // ////console.log("allVocherReceipts===", allVocherReceipts);
  // ////console.log("allVocherPayments==", allVocherPayments);
  // ////console.log("allPurchaseforms==", allPurchaseforms);

  const permissions = useSelector(selectMenuPermissions);
  // ////console.log("permissions=", permissions);

  const allPurchaseforms = useMemo(() => {
    return (allForms || [])
      .filter((item) => item.fmrTypeOfVoucher === "PURCHASE")
      .map((item) => ({
        id: item.fmrEntryNo,
        label: item.fmrName,
        entryNo: item.fmrEntryNo,
        fmrName: item.fmrName,
        abbr: item.fmrAbbreviation,
        voucherType: item.fmrTypeOfVoucher,
        key: undefined
      }));
  }, [allForms]);

  const allGoldReceipts = useMemo(() => {
    return (allForms || [])
      .filter((item) => item.fmrTypeOfVoucher === "GOLD RECEIPT")
      .map((item) => ({
        id: item.fmrEntryNo,
        label: item.fmrName,
        entryNo: item.fmrEntryNo,
        fmrName: item.fmrName,
        abbr: item.fmrAbbreviation,
        voucherType: item.fmrTypeOfVoucher,
        key: undefined
      }));
  }, [allForms]);

  const allSmithReceipts = useMemo(() => {
    return (allForms || [])
      .filter((item) => item.fmrTypeOfVoucher === "SMITH RECEIPT")
      .map((item) => ({
        id: item.fmrEntryNo,
        label: item.fmrName,
        entryNo: item.fmrEntryNo,
        fmrName: item.fmrName,
        abbr: item.fmrAbbreviation,
        voucherType: item.fmrTypeOfVoucher,
        key: undefined
      }));
  }, [allForms]);

  const allWorkInEntry = useMemo(() => {
    return (allForms || [])
      .filter((item) => item.fmrTypeOfVoucher === "WORK ENTRY-IN")
      .map((item) => ({
        id: item.fmrEntryNo,
        label: item.fmrName,
        entryNo: item.fmrEntryNo,
        fmrName: item.fmrName,
        abbr: item.fmrAbbreviation,
        voucherType: item.fmrTypeOfVoucher,
        key: undefined
      }));
  }, [allForms]);

  const allRefinerEntryFrom = useMemo(() => {
    return (allForms || [])
      .filter((item) => item.fmrTypeOfVoucher === "REFINER ENTRY-FROM")
      .map((item) => ({
        id: item.fmrEntryNo,
        label: item.fmrName,
        entryNo: item.fmrEntryNo,
        fmrName: item.fmrName,
        abbr: item.fmrAbbreviation,
        voucherType: item.fmrTypeOfVoucher,
        key: undefined
      }));
  }, [allForms]);

  const allReceipts = useMemo(() => {
    return (allForms || [])
      .filter(
        (item) =>
          item.fmrTypeOfVoucher === "SCHEME RECEIPT" ||
          item.fmrTypeOfVoucher === "Scheme Receipt Order"
      )
      .map((item) => ({
        id: item.fmrEntryNo,
        label: item.fmrAbbreviation,
        entryNo: item.fmrEntryNo,
        fmrName: item.fmrName,
        abbr: item.fmrAbbreviation,
        voucherType: item.fmrTypeOfVoucher,
        key: undefined
      }));
  }, [allForms]);

  const allVocherReceipts = useMemo(() => {
    return (allForms || [])
      .filter((item) => item.fmrTypeOfVoucher === "RECEIPT")
      .map((item) => ({
        id: item.fmrEntryNo,
        label: item.fmrName,
        entryNo: item.fmrEntryNo,
        fmrName: item.fmrName,
        abbr: item.fmrAbbreviation,
        voucherType: item.fmrTypeOfVoucher,
        key: undefined
      }));
  }, [allForms]);

  const allVocherPayments = useMemo(() => {
    return (allForms || [])
      .filter((item) => item.fmrTypeOfVoucher === "PAYMENT")
      .map((item) => ({
        id: item.fmrEntryNo,
        label: item.fmrName,
        entryNo: item.fmrEntryNo,
        fmrName: item.fmrName,
        abbr: item.fmrAbbreviation,
        voucherType: item.fmrTypeOfVoucher,
        key: undefined
      }));
  }, [allForms]);

  const allJournalForms = useMemo(() => {
    return (allForms || [])
      .filter((item) => item.fmrTypeOfVoucher === "JOURNAL")
      .map((item) => ({
        id: item.fmrEntryNo,
        label: item.fmrName,
        entryNo: item.fmrEntryNo,
        fmrName: item.fmrName,
        abbr: item.fmrAbbreviation,
        voucherType: item.fmrTypeOfVoucher,
        key: undefined
      }));
  }, [allForms]);

  const allRedeemForms = useMemo(() => {
    return (allForms || [])
      .filter((item) => item.fmrTypeOfVoucher === "SCHEME REDEEM")
      .map((item) => ({
        id: item.fmrEntryNo,
        label: item.fmrAbbreviation,
        entryNo: item.fmrEntryNo,
        fmrName: item.fmrName,
        abbr: item.fmrAbbreviation,
        voucherType: item.fmrTypeOfVoucher,
        key: undefined
      }));
  }, [allForms]);

  const navItems = [
    {
      name: "File",
      subName: "file",
      options: [
        {
          name: "Form Registration",
          subName: "formRegistration",
          subOptions: [],
        },
        { name: "Change Date", subName: "changeDate", subOptions: [] },
        {
          name: "Financial Year Registration",
          subName: "fyregistration",
          subOptions: [],
        },
        { name: "Create Company", subName: "createCompany", subOptions: [] },
        { name: "Open Company", subName: "openCompany", subOptions: [] },
      ],
    },
    {
      name: "Master",
      subName: "master",
      options: [
        { name: "Product Registration", subName: "productReg", subOptions: [] },
        { name: "Rate Settings", subName: "rateSettings", subOptions: [] },
        {
          name: "Supplier Registration",
          subName: "supplierReg",
          subOptions: [],
        },
        {
          name: "Customer Registration",
          subName: "customerReg",
          subOptions: [],
        },
        {
          name: "Customer App Registration",
          subName: "customerAppReg",
          subOptions: [],
        },
        {
          name: "App Broadcast Manager",
          subName: "appBroadcastManager",
          subOptions: [],
        },
        {
          name: "App Config Master",
          subName: "appConfigMaster",
          subOptions: [],
        },
        {
          name: "Payment Gateway Settings",
          subName: "paymentGatewaySettings",
          subOptions: [],
        },
        { name: "Scheme Registration", subName: "schemeReg", subOptions: [] },
        {
          name: "Scheme Management",
          subName: "SchemeManagement",
          subOptions: [],
        },

        {
          name: "Tax group Registration",
          subName: "taxgroupReg",
          subOptions: [],
        },
        {
          name: "Account Registration",
          subName: "accountReg",
          subOptions: [
            { id: 1, label: "Group Registration", key: "groupReg" },
            { id: 2, label: "Ledger Registration", key: "ledgerReg" },
          ],
        },
        {
          name: "Other Registration",
          subName: "otherReg",
          subOptions: [
            { id: 1, label: "Stock Group", key: "stockGroup" },
            { id: 2, label: "Model Name Registration", key: "modelnameReg" },
            { id: 3, label: "Rate Class Registration", key: "rateclassReg" },
            { id: 4, label: "Staff Registration", key: "employeeReg" },
            { id: 5, label: "Other Registration", key: "otherReg" },
          ],
        },
        {
          name: "Gold Smith Registration",
          subName: "goldsmithReg",
          subOptions: [],
        },
        { name: "Refiner Registration", subName: "refinerReg", subOptions: [] },
        { name: "User Creation", subName: "createUser", subOptions: [] },
      ],
    },
    {
      name: "Entry",
      subName: "entry",
      options: [
        {
          name: "Purchase Entry",
          subName: "purchaseEntry",
          subOptions: allPurchaseforms,
        },
        { name: "Sales Entry", subName: "salesEntry", subOptions: [] },
        {
          name: "Scheme Cash Receipt",
          subName: "schemecashReceipt",
          subOptions: allReceipts,
        },
        { name: "Scheme Redeem", subName: "schemeRedeem", subOptions: allRedeemForms },
        { name: "Journal Entry", subName: "jvEntry", subOptions: allJournalForms },
        { name: "Contra Entry", subName: "cvEntry", subOptions: [] },
        {
          name: "Receipt Entry",
          subName: "rvEntry",
          subOptions: allVocherReceipts,
        },
        {
          name: "Payment Entry",
          subName: "pvEntry",
          subOptions: allVocherPayments,
        },
        {
          name: "Opening Stock Entry",
          subName: "openingstockEntry",
          subOptions: [],
        },
        {
          name: "Diamond Purchase Entry",
          subName: "diamondPEntry",
          subOptions: [],
        },
        { name: "Barcode Entry", subName: "barcodeEntry", subOptions: [] },
        { name: "Repair  Entry", subName: "repairEntry", subOptions: [] },
        { name: "Gold Receipt", subName: "goldReceipt", subOptions: allGoldReceipts },
        { name: "Gold Payment", subName: "goldPayment", subOptions: [] },
        {
          name: "Weight Adjustments",
          subName: "weightAdjustment",
          subOptions: [],
        },
        {
          name: "Stock Transactions",
          subName: "stockTransactions",
          subOptions: [],
        },
        {
          name: "Return Entry",
          subName: "returnEntry",
          subOptions: [
            { id: 1, label: "Purchase Return", key: "purchaseReturn" },
            { id: 2, label: "Sales Return", key: "salesReturn" },
          ],
        },
        {
          name: "Exchange Entry",
          subName: "exchangeEntry",
          subOptions: [
            { id: 1, label: "Exchange to Supplier", key: "exchangetoSupp" },
            { id: 2, label: "Exchange From Customer", key: "exchangefromCust" },
          ],
        },
        {
          name: "Gold Smith Entry/Work Entry",
          subName: "goldsmithEntry",
          subOptions: [
            { id: 1, label: "Issue", key: "issue" },
            ...(allSmithReceipts || []),
          ],
        },
        {
          name: "Gold Work Entry",
          subName: "goldworkEntry",
          subOptions: [
            ...(allWorkInEntry || []),
            { id: 2, label: "Work Out", key: "workOut" },
          ],
        },
        {
          name: "Refiner Entry",
          subName: "refinerEntry",
          subOptions: [
            { id: 1, label: "To Refiner Entry", key: "torefinerEntry" },
            ...(allRefinerEntryFrom || []),
          ],
        },
        { name: "Upi Payment", subName: "upipayment", subOptions: [] },
      ],
    },
    {
      name: "Records List",
      subName: "recordList",
      options: [
        { name: "Product List", subName: "productList", subOptions: [] },
        {
          name: "Opening Balance List",
          subName: "openingBList",
          subOptions: [],
        },
        { name: "Opening Stock List", subName: "openingSList", subOptions: [] },

        { name: "Ledger List", subName: "ledgerList", subOptions: [] },
        { name: "Supplier List", subName: "supplierList", subOptions: [] },
        { name: "Customer List", subName: "customerList", subOptions: [] },
        { name: "Gold Smith List", subName: "goldsmithList", subOptions: [] },

        { name: "Event Details", subName: "eventDetails", subOptions: [] },
        {
          name: "Scheme Overdue List",
          subName: "schemeoverdueList",
          subOptions: [],
        },
      ],
    },
    {
      name: "Inventory Reports",
      subName: "inventoryReports",
      options: [
        { name: "Purchase List", subName: "purchaseList", subOptions: [] },

        { name: "Sales List", subName: "salesList", subOptions: [] },
        {
          name: "Gold Receipt List",
          subName: "goldreceiptList",
          subOptions: [],
        },
        {
          name: "Gold Payment List",
          subName: "goldpaymentList",
          subOptions: [],
        },
        { name: "Making Charge  List", subName: "mcList", subOptions: [] },
        { name: "Sales Order List", subName: "soList", subOptions: [] },

        { name: "Rate List", subName: "rateList", subOptions: [] },
        { name: "Repair List", subName: "repairLst", subOptions: [] },
        {
          name: "Weight Adjustment List",
          subName: "weightadjList",
          subOptions: [],
        },
        { name: "Scheme Report", subName: "schemeReport", subOptions: [] },
        {
          name: "Stock Report",
          subName: "stockReport",
          subOptions: [
            { id: 1, label: "Stock Summary", key: "stockSummary" },
            { id: 2, label: "Diamond Stock Summary", key: "dstockSummary" },
            { id: 3, label: "Barcode List", key: "barcodeList" },
            { id: 4, label: "Stock Ledger", key: "stockLedger" },
            { id: 5, label: "Stock Above Max Level", key: "stockaboveLevel" },
            { id: 6, label: "Receipt/Sales Stock Ledger", key: "receiptstockLedger" },
            { id: 7, label: "Stock Adjustment Report", key: "stockadjReport" },
          ],
        },
        {
          name: "Return Report",
          subName: "returnReport",
          subOptions: [
            { id: 1, label: "Sales Return List", key: "salesretList" },
            { id: 2, label: "Purchase Return List", key: "purchaseretList" },
          ],
        },
        {
          name: "Exchange Report",
          subName: "exchangeReport",
          subOptions: [
            { id: 1, label: "Exchange to Supplier Report", key: "exchtosuppReport" },
            { id: 2, label: "Exchange From Customer Repirt", key: "exchfromcustReport" },
          ],
        },
        {
          name: "Refiner Report",
          subName: "refinerReport",
          subOptions: [
            { id: 1, label: "To Refiner", key: "toRefiner" },
            { id: 2, label: "From Refiner", key: "fromRefiner" },
          ],
        },
        {
          name: "Smith Report",
          subName: "smithReport",
          subOptions: [
            { id: 1, label: "Smith Issue List", key: "smithissueList" },
            { id: 2, label: "Smith Receipt List", key: "smithrecList" },
          ],
        },
        {
          name: "Work Report",
          subName: "workReport",
          subOptions: [
            { id: 1, label: "Work in Report", key: "workinReport" },
            { id: 2, label: "Work Out Report", key: "workoutReport" },
          ],
        },
      ],
    },
    {
      name: "Accounts Reports",
      subName: "accountReport",
      options: [
        { name: "Ledger Report", subName: "ledgerReport", subOptions: [] },
        { name: "Receipt List", subName: "receiptList", subOptions: [] },
        { name: "Group List", subName: "groupList", subOptions: [] },
        { name: "Payment List", subName: "paymentList", subOptions: [] },
        { name: "Journal List", subName: "journalList", subOptions: [] },
        { name: "Contra List", subName: "contraList", subOptions: [] },

        { name: "Agent Report", subName: "agentReport", subOptions: [] },
        { name: "Day Book", subName: "dayBook", subOptions: [] },
        {
          name: "Supplier Transaction",
          subName: "supplierTrans",
          subOptions: [],
        },
        { name: "Smith Transactions", subName: "smithTrans", subOptions: [] },
        { name: "Profit & Loss Account", subName: "profitandlossAcc", subOptions: [] },
        { name: "Balance Sheet", subName: "balanceSheet", subOptions: [] },
        { name: "Trail Balance", subName: "trailBalance", subOptions: [] },
        { name: "Balance Report", subName: "balanceReport", subOptions: [] },
        { name: "Sales Man Report", subName: "salesmanReport", subOptions: [] },
        { name: "Payables", subName: "payables", subOptions: [] },
        { name: "Receivables", subName: "receivables", subOptions: [] },
        { name: "Tax Report", subName: "taxReport", subOptions: [] },
        { name: "Closing Report", subName: "closingReport", subOptions: [] },
      ],
    },
    {
      name: "Tools",
      subName: "tools",
      options: [
        {
          name: "Software Settings",
          subName: "softwareSettings",
          subOptions: [],
          // subOptions: [
          //   [1, "Sms Settings", "changeDate"],
          //   [2, "WhatsApp Settings", "changeDate"],
          // ],
        },
        { name: "Search Barcode", subName: "searchBarcode", subOptions: [] },
        {
          name: "Invoice Designer",
          subName: "invoiceDesigner",
          subOptions: [],
        },
        {
          name: "Print Model Assigner",
          subName: "printModelAssigner",
          subOptions: [],
        },
        {
          name: "Change User Password",
          subName: "changeuPass",
          subOptions: [],
        },
        {
          name: "Barcode Designer",
          subName: "barcodeDesigner",
          subOptions: [],
        },
        { name: "Print Barcode ", subName: "printBarcode", subOptions: [] },
        {
          name: "Message Sender",
          subName: "messageSender",
          subOptions: [
            { id: 1, label: "Sms Sender", key: "smsSender" },
            { id: 2, label: "WhatsApp Sender", key: "whatsappSender" },
          ],
        },
        {
          name: "Stock Adjustments",
          subName: "stockAdjustments",
          subOptions: [
            { id: 1, label: "Stock Adjustments", key: "stockAdj" },
            { id: 2, label: "Stock Checking", key: "stockChecking" },
            { id: 3, label: "Delete Out of Stock Products", key: "deleteoutofstockPrd" },
            { id: 4, label: "Delete Zero Stock Items", key: "deletezerostockeItm" },
            { id: 5, label: "Edit Product Details ", key: "editprodDetails" },
          ],
        },
      ],
    },
    {
      name: "System",
      subName: "system",
      options: [
        { name: "BackUp", subName: "backUp", subOptions: [] },
        { name: "Update", subName: "update", subOptions: [] },

        { name: "Search", subName: "quickSearch", subOptions: [] },
      ],
    },
  ];

  const filteredNavItems = useMemo(() => {
    const filterItems = (items) => {
      return items
        .map((item) => {
          const subName = item.subName;
          if (subName && permissions[subName] && permissions[subName].visible === false) return null;

          const newItem = { ...item };
          if (newItem.options) {
            newItem.options = filterItems(newItem.options).filter(Boolean);
            if (newItem.options.length === 0) return null; // Remove parent if no children
          }
          if (newItem.subOptions) {
            newItem.subOptions = newItem.subOptions.filter((sub) => {
              const subKey = typeof sub === "object" ? sub.key : sub[2];
              // If subKey is undefined, include the sub-option
              if (!subKey) return true;
              // Otherwise, check permissions for subName (default true if not set)
              return permissions[subKey]?.visible ?? true;
            });
            // Optionally, remove parent if no subOptions (uncomment if needed)
            // if (newItem.subOptions.length === 0) return null;
          }
          return newItem;
        })
        .filter(Boolean); // Remove null items
    };
    return filterItems(navItems);
  }, [
    permissions,
    allReceipts,
    allVocherReceipts,
    allVocherPayments,
    allPurchaseforms,
    allJournalForms,
    allGoldReceipts,
    allSmithReceipts,
    allWorkInEntry,
    allRefinerEntryFrom,
    allRedeemForms,
  ]); // Added dynamic props as dependencies

  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeSubDropdown, setActiveSubDropdown] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [subMenuPos, setSubMenuPos] = useState({ top: 0, left: 0 });

  const handleToggleDropdown = (itemName) => {
    setActiveDropdown((prevItem) => (prevItem === itemName ? null : itemName));
    setActiveSubDropdown(null);
    setSelectedOption(null);
  };

  const closeDropdown = () => {
    setActiveDropdown(null);
    setActiveSubDropdown(null);
    setSelectedOption(null);
  };

  const handleToggleSubDropdown = (optionName, e) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    setSubMenuPos({ top: rect.top, left: rect.right + 4 });
    setActiveSubDropdown((prevOption) =>
      prevOption === optionName ? null : optionName
    );
  };

  const handleOptionSelectNav = (option) => {
    console.log("selected Option===", option);

    closeDropdown();

    const optionLabel = typeof option === "object" ? (option.label || option.name) : option;
    const optionId = typeof option === "object" ? option.id : undefined;
    const optionKey = typeof option === "object" ? option.key : undefined;
    const optionVoucherType = typeof option === "object" ? option.voucherType : undefined;

    if (optionLabel === "User Creation") {
      openCreateUserModal();
    } else if (optionLabel === "Receipt List") {
      openReceiptListModal();
    } else if (optionLabel === "Form Registration") {
      openFormRegModal();
    } else if (optionLabel === "Product Registration") {
      openProductRegModal();
    } else if (optionLabel === "Day Book") {
      openDayBookModal();
    } else if (optionLabel === "Journal Entry") {
      openJvModal();
    } else if (
      allJournalForms &&
      allJournalForms.some((receipt) => receipt.label === optionLabel)
    ) {
      openJvModal(optionId, optionLabel, optionVoucherType);
    } else if (optionLabel === "Contra Entry") {
      openCvModal(optionId, optionLabel, optionVoucherType);
    } else if (
      allPurchaseforms.some((receipt) => receipt.label === optionLabel)
    ) {
      openPEntry(optionId, optionLabel, optionVoucherType);
    } else if (optionLabel === "Ledger Report") {
      openLedgerDiaModal();
    } else if (optionLabel === "Agent Report") {
      openAgReportDiaModal();
    } else if (optionLabel === "Search") {
      openQuickSearchModal();
    } else if (optionLabel === "BackUp") {
      downloadBackup();
    } else if (
      allReceipts.some((receipt) => receipt.label === optionLabel)
    ) {
      openReceiptModal(optionId, optionLabel, optionVoucherType);
    } else if (
      allVocherReceipts.some((receipt) => receipt.label === optionLabel)
    ) {
      openCashRec(optionId, optionLabel, optionVoucherType);
    } else if (
      allVocherPayments.some((receipt) => receipt.label === optionLabel)
    ) {
      openCashPay(optionId, optionLabel, optionVoucherType);
    } else if (
      allGoldReceipts &&
      allGoldReceipts.some((receipt) => receipt.label === optionLabel)
    ) {
      if (openGoldReceipt) {
        openGoldReceipt(optionId, optionLabel, optionVoucherType);
      }
    } else if (
      allSmithReceipts &&
      allSmithReceipts.some((receipt) => receipt.label === optionLabel)
    ) {
      if (openGoldReceipt) {
        openGoldReceipt(optionId, optionLabel, optionVoucherType);
      }
    } else if (
      allWorkInEntry &&
      allWorkInEntry.some((receipt) => receipt.label === optionLabel)
    ) {
      if (openGoldReceipt) {
        openGoldReceipt(optionId, optionLabel, optionVoucherType);
      }
    } else if (
      allRefinerEntryFrom &&
      allRefinerEntryFrom.some((receipt) => receipt.label === optionLabel)
    ) {
      if (openGoldReceipt) {
        openGoldReceipt(optionId, optionLabel, optionVoucherType);
      }
    } else if (
      optionLabel === "Sms Settings" ||
      optionLabel === "Sms Sender" ||
      optionKey === "smsSender"
    ) {
      if (openSmsSettings) openSmsSettings();
    } else if (
      optionLabel === "WhatsApp Settings" ||
      optionLabel === "WhatsApp Sender" ||
      optionKey === "whatsappSender"
    ) {
      if (openWhatsAppSettings) openWhatsAppSettings();
    } else if (optionLabel === "Ledger List" || optionKey === "ledgerList") {
      if (openLedgerListModal) openLedgerListModal();
    } else if (optionLabel === "Supplier List" || optionKey === "supplierList") {
      if (openLedgerListModal) openLedgerListModal("SUPPLIERS");
    } else if (optionLabel === "Customer List" || optionKey === "customerList") {
      if (openLedgerListModal) openLedgerListModal("CUSTOMERS");
    } else if (optionLabel === "Scheme Overdue List") {
      openOverDueListModal();
    } else if (optionLabel === "Event Details") {
      openEventDetailsModal();
    } else if (optionLabel === "Rate Settings") {
      openRateSettingsModal();
    } else if (optionLabel === "Rate Class Registration") {
      openRateClassModal();
    } else if (optionLabel === "Stock Group") {
      openStockGroupModal();
    } else if (optionLabel === "Model Name Registration") {
      openModelRegModal && openModelRegModal();
    } else if (optionLabel === "Staff Registration") {
      openStaffRegModal && openStaffRegModal();
    } else if (optionLabel === "Scheme Registration") {
      openRegistrationModal();
    } else if (optionLabel === "Scheme Management") {
      openSchManagementModal();
    } else if (optionLabel === "Ledger Registration") {
      openLedgerRegModal();
    } else if (optionLabel === "Customer App Registration") {
      openCustomerAppRegModal && openCustomerAppRegModal();
    } else if (optionLabel === "App Broadcast Manager") {
      openAppBroadcastManager && openAppBroadcastManager();
    } else if (optionLabel === "App Config Master") {
      openAppConfigMaster && openAppConfigMaster();
    } else if (optionLabel === "Payment Gateway Settings") {
      openPaymentGatewaySettings && openPaymentGatewaySettings();
    } else if (optionLabel === "Invoice Designer") {
      openInvoiceDesigner && openInvoiceDesigner();
    } else if (optionLabel === "Print Model Assigner") {
      openPrintModelAssigner && openPrintModelAssigner();
    } else if (optionLabel === "Other Registration") {
      openOtherRegModal();
    } else if (
      allRedeemForms.some((redeem) => redeem.label === optionLabel)
    ) {
      openRedeemModal(optionId, optionLabel, optionVoucherType);
    } else if (optionLabel === "Scheme Redeem") {
      openRedeemModal();
    } else if (optionLabel === "Software Settings") {
      openSoftwareSettings();
    } else if (optionLabel === "Financial Year Registration") {
      openFinancialYear();
    } else if (optionLabel === "Group List") {
      openGroupListModal();
    } else if (optionLabel === "Group Registration") {
      console.log("group registration opened");
      openGroupreg();
    } else if (optionLabel === "Purchase List" || optionKey === "purchaseList") {
      openPurchaseList();
    } else if (
      optionLabel === "Scheme Report" ||
      optionKey === "schemeReport"
    ) {
      if (openSchemeReport) openSchemeReport();
    }
  };

  const handleKeyDownNav = (e, options) => {
    if (e.key === "Escape") {
      closeDropdown();
      return;
    }
    if (activeDropdown) {
      let index = selectedOption !== null ? selectedOption : -1;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        index = (index + 1) % options.length;
        setSelectedOption(index);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        index = (index - 1 + options.length) % options.length;
        setSelectedOption(index);
      } else if (e.key === "Enter" && index !== -1) {
        handleOptionSelectNav(options[index]);
      }
    }
  };

  useEffect(() => {
    const closeDropdownOnClickOutside = () => {
      setActiveDropdown(null);
      setActiveSubDropdown(null);
      setSelectedOption(null);
    };
    document.addEventListener("click", closeDropdownOnClickOutside);
    return () => {
      document.removeEventListener("click", closeDropdownOnClickOutside);
    };
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

        .pnav-bar {
          position: absolute;
          top: 0;
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          gap: 3px;
          padding: 0 14px;
          background: #0b2260;
          height: 46px;
          box-sizing: border-box;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          z-index: 1000000;
          font-family: 'Inter', sans-serif;
        }

        .pnav-item {
          position: relative;
          padding: 6px 13px;
          cursor: pointer;
          color: rgba(255, 255, 255, 0.92);
          font-size: 13.5px;
          font-weight: 500;
          letter-spacing: 0.2px;
          border-radius: 6px;
          transition: all 0.16s cubic-bezier(0.16, 1, 0.3, 1);
          user-select: none;
          white-space: nowrap;
        }
        .pnav-item:hover {
          background: rgba(255, 255, 255, 0.12);
          color: #ffffff;
        }
        .pnav-item.active {
          background: rgba(255, 255, 255, 0.2);
          color: #ffffff;
          box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.15);
        }

        .pnav-dropdown {
          position: absolute;
          top: calc(100% + 4px);
          left: 0;
          min-width: 220px;
          background: #ffffff;
          border-radius: 8px;
          box-shadow: 0 12px 36px -4px rgba(11, 34, 96, 0.22), 0 4px 12px -2px rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(11, 34, 96, 0.12);
          z-index: 10000;
          padding: 5px;
          animation: pnav-fadedown 0.16s cubic-bezier(0.16, 1, 0.3, 1);
          transform-origin: top left;
          max-height: 80vh;
          overflow-y: auto;
          overflow-x: hidden;
          scrollbar-width: thin;
          scrollbar-color: #cbd5e1 transparent;
        }
        @keyframes pnav-fadedown {
          from {
            opacity: 0;
            transform: translateY(-6px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        .pnav-option {
          position: relative;
          display: flex;
          align-items: center;
          min-height: 34px;
          padding: 0 12px;
          cursor: pointer;
          font-size: 13px;
          font-weight: 450;
          color: #1e293b;
          white-space: nowrap;
          transition: all 0.14s ease;
          border-radius: 6px;
          margin: 1px 0;
        }
        .pnav-option:hover,
        .pnav-option.active {
          background: #eff6ff;
          color: #0b2260;
          font-weight: 500;
          padding-left: 14px;
        }
        .pnav-option .pnav-arrow {
          margin-left: auto;
          width: 15px;
          height: 15px;
          color: #94a3b8;
          flex-shrink: 0;
          transition: transform 0.15s ease, color 0.15s ease;
        }
        .pnav-option:hover .pnav-arrow,
        .pnav-option.active .pnav-arrow {
          color: #0b2260;
          transform: translateX(2px);
        }

        .pnav-subdropdown {
          position: fixed;
          min-width: 210px;
          background: #ffffff;
          border-radius: 8px;
          box-shadow: 0 12px 36px -4px rgba(11, 34, 96, 0.22), 0 4px 12px -2px rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(11, 34, 96, 0.12);
          z-index: 99999;
          padding: 5px;
          animation: pnav-subfadedown 0.16s cubic-bezier(0.16, 1, 0.3, 1);
          transform-origin: top left;
          overflow-y: auto;
          scrollbar-width: thin;
          scrollbar-color: #cbd5e1 transparent;
        }
        @keyframes pnav-subfadedown {
          from {
            opacity: 0;
            transform: translateX(-6px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateX(0) scale(1);
          }
        }

        .pnav-suboption {
          display: flex;
          align-items: center;
          min-height: 32px;
          padding: 0 12px;
          cursor: pointer;
          font-size: 12.5px;
          font-weight: 450;
          color: #1e293b;
          white-space: nowrap;
          transition: all 0.14s ease;
          border-radius: 6px;
          margin: 1px 0;
        }
        .pnav-suboption:hover {
          background: #eff6ff;
          color: #0b2260;
          font-weight: 500;
          padding-left: 14px;
        }

        .pnav-divider {
          height: 1px;
          background: #f1f5f9;
          margin: 4px 6px;
        }
      `}</style>

      <div
        className="pnav-bar"
        onClick={closeDropdown}
        onKeyDown={(e) =>
          handleKeyDownNav(
            e,
            filteredNavItems.find((item) => item.name === activeDropdown)
              ?.options || []
          )
        }
        tabIndex="0"
      >
        {filteredNavItems.map((item) => (
          <div
            key={item.name}
            className={`pnav-item${activeDropdown === item.name ? " active" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              handleToggleDropdown(item.name);
            }}
            onMouseEnter={() => {
              if (activeDropdown && activeDropdown !== item.name) {
                setActiveDropdown(item.name);
                setActiveSubDropdown(null);
                setSelectedOption(null);
              }
            }}
          >
            {item.name}

            {item.options.length > 0 && activeDropdown === item.name && (
              <div className="pnav-dropdown" onClick={(e) => e.stopPropagation()}>
                {item.options.map((option, index) => (
                  <div key={index}>
                    <div
                      className={`pnav-option${activeSubDropdown === option.name ? " active" : ""}${selectedOption === index ? " active" : ""}`}
                      onMouseEnter={(e) => {
                        if (option.subOptions && option.subOptions.length > 0) {
                          const rect = e.currentTarget.getBoundingClientRect();
                          setSubMenuPos({ top: rect.top, left: rect.right + 4 });
                          setActiveSubDropdown(option.name);
                        } else {
                          setActiveSubDropdown(null);
                        }
                      }}
                      onClick={(e) => {
                        if (option.subOptions.length > 0) {
                          handleToggleSubDropdown(option.name, e);
                        } else {
                          handleOptionSelectNav(option.name);
                          e.stopPropagation();
                        }
                      }}
                    >
                      <span>{option.name}</span>
                      {option.subOptions.length > 0 && (
                        <FiChevronRight className="pnav-arrow" />
                      )}

                      {activeSubDropdown === option.name && option.subOptions.length > 0 && (
                        <div
                          className="pnav-subdropdown"
                          style={{
                            top: subMenuPos.top,
                            left: subMenuPos.left,
                            maxHeight: `min(80vh, calc(100vh - ${subMenuPos.top}px - 10px))`,
                          }}
                        >
                          {option.subOptions.map((subOption, subIndex) => (
                            <div
                              key={subIndex}
                              className="pnav-suboption"
                              onClick={(e) => {
                                handleOptionSelectNav(subOption);
                                e.stopPropagation();
                              }}
                            >
                              {subOption.label}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}

        {userType === "ADMIN" && (
          <div style={{ marginLeft: "auto", paddingRight: "20px" }}>
            <Notifications dbCode={dbCode} />
          </div>
        )}
      </div>
    </>
  );
};

export default MenuBar;
